var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tel-input',{attrs:{"preferredCountries":['US'],"invalidMsg":"Phone number is invalid!","inputOptions":{required: true, placeholder: 'Enter phone number'},"validCharactersOnly":"","id":"phone-input"},on:{"input":_vm.assignPhone},model:{value:(_vm.initialPhone),callback:function ($$v) {_vm.initialPhone=$$v},expression:"initialPhone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }